export default "__VITE_ASSET__CaBE1wD8__"